<template>
    <main class="main" id="main" v-if="categories !== null">
        <div class="main_top_line">
            <div class="container">
                <div class="mobile_column">
                    <div class="m_tl_text">
                        <h1>Введите адрес доставки</h1>
                    </div>
                    <div class="address_form">
                        <input type="text" name="" placeholder="город, улица, дом" id="address" ref="address" v-model="geo.address">
                        <div class="m_tl_icons main_page">
                            <div class="map"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/map.svg" @click="showMap" alt=""></div>
                            <div class="micro" style="display: none"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/micro.svg" alt=""></div>
                            <button type="submit" class="search"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/search.svg" alt=""></button>
                        </div>
                        <button type="submit" class="green_btn main_btn" @click="sendAdr">Поиск вкусной еды</button>
                    </div>
                </div>
            </div>
        </div>
        <!----------Section food cards------------->

        <section class="section">
            <div class="container">
                <div class="food_cards">
                    <router-link tag="div" to="/restaurants" class="card_inner">
                        <img class="card_fit" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/1.png" alt="">
                        <p class="card_description">Все рестораны</p>
                    </router-link>
                    <router-link tag="div" :to="'/product/' + category.id" v-if="category.id !== 24" class="card_inner" v-for="(category, index) in categories" :key="index">
                        <img v-if="index < display" :src="category.img" class="big_card" alt="">
                        <img v-else :src="category.img" class="small_card">
                        <p class="card_description">{{category.name}}</p>
                    </router-link>
                </div>
            </div>
        </section>

        <div class="main_top_line main_pg" v-if="Object.keys(stocks).length">
            <div class="container">
                <div class="top_line_column">
                    <h1>Акции в вашем городе</h1>
                </div>
            </div>
        </div>

        <section class="section s-sales" v-if="Object.keys(stocks).length">
            <div class="container">
                <div class="sales_cards sales_slider">

                    <div class="sales_inner slick-slide" v-for="(stock, index) in stocks" :key="index">
                        <div class="sales_header">
                            <img :src="stock.restaurant.logo">
                            <div class="sales_time">
                                <countdown tag="h2" :time="new Date((stock.to).split('.')[2],(stock.to).split('.')[1]-1,(stock.to).split('.')[0]) - new Date()">
                                    <template slot-scope="props" v-if="props.days > 0">{{ props.days }} дней</template>
                                    <template slot-scope="props" v-else>{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</template>
                                </countdown>
                                <span>до конца акции</span>
                            </div>
                        </div>
                        <div class="sub_title">
                          <h1>{{stock.text}}</h1>
                        </div>
                        <div class="sales_image">
                            <img :src="stock.photo" alt="">
                        </div>
                        <div class="sales_bottom">
                            <p>{{stock.description}}</p>
                            <button type="button" class="menu_item_btn" @click="putInBasket(stock.product_id, stock.restaurant.id)">Получить</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="main_top_line main_pg">
            <div class="container">
                <div class="top_line_column">
                    <div class="m_tl_text">
                        <h1>Получи 100 рублей на телефон при любом заказе</h1>
                        <router-link tag="span" class="link" to="/rules">Пользовательское соглашение</router-link>
                    </div>
                    <div class="m_tl_icons">
                        <a href="#"><div class="icon icon1"></div></a>
                        <a href="#"><div class="icon icon2"></div></a>
                        <a href="#"><div class="icon icon3"></div></a>
                        <a href="#"><div class="icon icon4"></div></a>
                        <!-- <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div> -->
                    </div>
                    <div class="m_tl_text">
                        <h1>Получи 200 рублей за регистрацию на бонусный счёт</h1>
                    </div>
                    <button class="green_btn" @click="showModal('register')">Получить</button>

                </div>
            </div>
        </div>

        <!----------Section advantages------------->

        <section class="section s-advantages">
          <div class="delicious_food">
            <img class="advantages_bg" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/section_bg.png" />
            <div class="left_column">
              <div class="advantages_row">

                <div class="hungry">
                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/pot.svg" alt="">
                  <h1>Решили вкусно поесть?</h1>
                </div>
                <div class="fork">
                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/fork.svg" alt="">
                  <p>но не хотите готовить или идти покупать?</p>
                </div>

              </div>
              <div class="food_order">
                <h4>Сделайте заказ за 2 минуты и курьер уже выезжает к вам</h4>
                <p>Служба доставки еды ХОЧУ-ПОЕСТЬ.РФ в городе {{city.name}} - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.</p>
              </div>
            </div>
          </div>
          <div class="another_advantages">
            <div class="right_column">

              <div class="advantage_explanation">
                <div class="advantage_title">
                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/adv_1.svg" alt="">
                  <span>Зарабатывайте с нами</span>
                </div>
                <p>
                  Только у нас вы можете заказать еду бесплатно! Пицца, роллы, суши, бургеры и многое другое. С нами можно зарабатывать реальные деньги и оплачивать ими заказ. Пишите отзывы, зовите друзей, добавляйтесь в социальные сети и снимайте обзоры на нашу доставку.  Мы все оплатим! А еще вы можете обменивать свои бонусы на подарки от наших партнеров.
                </p>
              </div>

              <div class="advantage_explanation">
                <div class="advantage_title">
                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/adv_2.svg" alt="">
                  <span>ЗАКАЗЫВАЙТЕ БЕСПЛАТНО</span>
                </div>
                <p>
                  Мы готовы доставлять вам еду 24 часа 7 дней в неделю! Мы специально подобрали рестораны, которые работают круглосуточно, чтобы не оставить Вас голодными даже ночью. Осталось только выбрать блюдо, оплатить и дождаться курьера. А широкий ассортимент точно Вас порадует.
                </p>
              </div>

              <div class="advantage_explanation">
                <div class="advantage_title">
                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/adv_3.svg" alt="">
                  <span>Еда в офис</span>
                </div>
                <p>
                  Проводишь больше времени в офисе, чем дома? Мечтаешь о вкусном горячем обеде? Мы поможем.  Бесплатно доставим бизнес-ланчи по очень выгодной цене прямо в офис. Не забудь про наши «счастливые часы» и акции. У нас максимально выгодно и вкусно.
                </p>
              </div>

              <div class="advantage_explanation">
                <div class="advantage_title">
                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/adv_4.svg" alt="">
                  <span>РЕАЛЬНЫЕ ДЕНЬГИ, А НЕ БОНУСЫ!</span>
                </div>
                <p>
                  Ты накопил уже 1000 бонусов на сайте, а купить можешь всего лишь бургер за 70 рублей. Знакомо? У нас все по другому! Никаких непонятых псевдобонусов. 1 рубль - это 1 рубль и точка. Получаете при регистрации 200 рублей, приводите друга - еще 200 рублей. Оплачивайте от 10 до 30% вашего заказа и будьте счастливы.
                </p>
              </div>

            </div>
          </div>
        </section>

        <div class="popup_result" v-if="$route.path === '/success' && !hide">
          <div class="container">
            <div class="result_box success">
              <div class="result">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/checked_attr.svg"/>
              </div>
              <h2>Спасибо!</h2>
              <p>Ваш заказ успешно передан в работу!</p>
              <button class="close_btn" @click="hide = 1">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/cross.svg" />
              </button>
            </div>
          </div>
        </div>
        <div class="popup_result" v-if="$route.path === '/fail' && !hide">
          <div class="container">
            <div class="result_box fail">
              <div class="result">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/cross.svg" />
              </div>
              <p>Упс... что то пошло не так...</p>
              <h2>Ваш платёж не прошёл(</h2>
              <button class="close_btn" @click="hide = 1">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/cross.svg" />
              </button>
            </div>
          </div>
        </div>
    </main>
    <main class="main" id="main" v-else>
        <section class="section s-choose_restaurant">
            <div class="container">
                <div class="catch_moment_box">
                    <img class="text_img" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/text.png"/>
                    <div class="catch_moment_slider">
                        <div class="slick-slide">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/pizza.png" />
                        </div>
                        <div class="slick-slide">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/pizza.png" />
                        </div>
                        <div class="slick-slide">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/pizza.png" />
                        </div>
                        <div class="slick-slide">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/pizza.png" />
                        </div>
                    </div>
                </div>
                <div class="restaurants_form_box">
                    <div class="title">
                        <h1>ЗДЕСЬ БУДУТ ЛУЧШИЕ РЕСТОРАНЫ ТВОЕГО ГОРОДА</h1>
                        <p>А пока мы в поиске.. помоги нам открыться быстрее?<br />Напиши название твоего любимогот ресторана с доставкой и стань VIP-гостем ХОЧУ ПОЕСТЬ! <strong>Навсегда!</strong></p>
                    </div>
                    <div class="restaurants_form">
                        <div class="extra_info">
                            <div class="info_item">
                                <h2>У вас есть ресторан?<br />У нас для вас отличные новости!</h2>
                                <router-link tag="button" to="/restaurants_services" class="menu_item_btn">Узнать</router-link>
                            </div>
                            <div class="info_item">
                                <h2>Хотите открыть сервис в своём городе?</h2>
                                <router-link tag="button" to="/franchise" class="menu_item_btn green">Открыть</router-link>
                            </div>
                            <div class="info_item" v-if="city.fb || city.ok || city.telegram || city.vk">
                                <h2>Не пропустите открытие, следите за нами в соцсетях!</h2>
                                <div class="socials">
                                  <a class="social_link" v-if="city.fb" :href="city.fb">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/fb.svg" />
                                  </a>
                                  <a class="social_link" v-if="city.ok" :href="city.ok">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/odkl.svg" />
                                  </a>
                                  <a class="social_link" v-if="city.telegram" :href="city.telegram">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/tlg.svg" />
                                  </a>
                                  <a class="social_link" v-if="city.vk" :href="city.vk">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/vk.svg" />
                                  </a>
                                </div>
                            </div>
                        </div>
                        <form class="main_form">
                            <h2>Как только мы начнём принимать заказы, сообщим вам об этом и начислим <strong>1000 бонусных рублей!</strong></h2>

                            <div class="input_order">
                                <input type="text" name="" class="order" v-model="name" required>
                                <div class="placeholder">
                                    Ваше имя <span>*</span>
                                </div>
                            </div>

                            <div class="input_order">
                                <input type="text" name="" class="order" v-model="restaurant_name" required>

                                <div class="placeholder">
                                    Ссылка на ресторан или его название <span>*</span>
                                </div>
                            </div>

                            <div class="input_order">
                                <input type="text" name="" class="order" v-model="phone" data-inputmask="'mask': '+9(999)999-99-99'" required>

                                <div class="placeholder">
                                    +7(__)__-__-__ <span>*</span>
                                </div>
                            </div>

                            <div class="input_order">
                                <input type="text" name="" class="order" v-model="email"  required>

                                <div class="placeholder">
                                    user@domain.com <span>*</span>
                                </div>
                            </div>
                            <button class="menu_item_btn" @click="sendOffer">ПРИСОЕДИНИТЬСЯ</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import $ from 'jquery'
import axios from '@/router/http'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel'
import countdown from '@chenfengyuan/vue-countdown'
export default {
  name: 'index',
  props: ['city', 'mapinit', 'geo', 'auth'],
  components: {countdown},
  data () {
    return {
      categories: {},
      stocks: {},
      map: null,
      geocoder: null,
      autocomplete: [],
      address: null,
      hideGeo: 0,
      selectAddress: 0,
      initAutocompleteInterval: null,
      display: 3,
      hide: 0,
      name: null,
      restaurant_name: null,
      phone: null,
      email: null
    }
  },
  watch: {
    stocks: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal && Object.keys(this.stocks).length > 2) {
          //  if ($('.sales_slider').length) $('.sales_slider.slick-slider').slick('unslick')
          setTimeout(() => {
            $('.sales_slider').slick({
              dots: false,
              arrows: true,
              speed: 300,
              slidesToShow: 3,
              swipeToSlide: true,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 976,
                  settings: {
                    dots: false,
                    speed: 300,
                    slidesToShow: 2,
                    swipeToSlide: true,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    dots: false,
                    speed: 300,
                    slidesToShow: 1,
                    swipeToSlide: true,
                    slidesToScroll: 1
                  }
                }
              ]
            })
          }, 500)
        }
      },
      deep: true
    },
    'geo.address' (val) {
      if (!val || val === '' || val === ' ') {
        this.geo.lat2 = null
        this.geo.lng2 = null
        this.geo.lat = null
        this.geo.lng = null
        var formData = new FormData()
        formData.append('lat', null)
        formData.append('lng', null)
        formData.append('address', null)
        formData.append('country', this.auth.country)
        formData.append('city', this.auth.city)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-mobile',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    },
    'auth.city' (val) {
      this.initAjax()
    },
    'auth.setNewAdr' (val) {
      this.initAjax()
    }
  },
  mounted () {
    if (this.$route.meta.header === 1) {
      setTimeout(() => {
        $('.header_slider').slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          fade: true,
          slidesToShow: 1,
          swipeToSlide: false,
          slidesToScroll: 1
        })
      }, 500)
    }
    $('.main_block_cont').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      arrows: false
    })
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
    this.initMap()
  },
  metaInfo () {
    return {
      meta: [
        { vmid: 'description', name: 'description', property: 'description', content: 'Доставка еды из лучших ресторанов в г.' + this.city.name + '. Бесплатная доставка суши, роллов, пиццы, бургеров и еще 1000 блюд без комиссии и наценок. Реальные 200 рублей, а не бонусов за регистрацию. Акции и скидки из всех ресторанов на одном сайте.' }
      ]
    }
  },
  methods: {
    showModal (val) {
      this.$root.modals = val
    },
    sendAdr () {
      if (this.geo.address && this.geo.lat && this.geo.lng) {
        this.$router.push({name: 'restaurants'})
      } else alert('Укажите адрес доставки')
    },
    putInBasket (id, rest) {
      if (this.$root.geo.address && this.$root.geo.lat2 && this.$root.geo.lng2) {
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.$root.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-in-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
          this.$router.push({ name: 'restaurant', params: { id: rest } })
        })
      } else this.$root.modals = 'selectCity'
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    sendGeo () {
      this.hideGeo = 1
      var formData = new FormData()
      this.geo.lat2 = this.geo.lat
      this.geo.lng2 = this.geo.lng
      formData.append('lat', this.geo.lat)
      formData.append('lng', this.geo.lng)
      formData.append('address', this.geo.address)
      formData.append('country', this.auth.country)
      formData.append('city', this.geo.city)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    },
    changePlace (place, value, save) {
      var city
      var i
      for (i = 0; i < place.address_components.length; i++) {
        if (place.address_components[i].types[0] === 'locality') city = place.address_components[i]['long_name']
      }
      if (city === 'Київ') city = 'Киев'
      if (city === 'Днипро') city = 'Днепр'
      if (city === 'Дніпро́') city = 'Днепр'
      if (city === 'Одеса' || city === undefined || city === '') {
        for (i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] === 'political' || place.address_components[i].types[0] === 'administrative_area_level_1') city = place.address_components[i]['long_name']
        }
      }
      this.geo.address = value
      this.geo.lat = place.geometry.location.lat()
      this.geo.lng = place.geometry.location.lng()
      this.geo.city = city
      this.auth.city = city
      if (save) {
        this.geo.lat2 = this.geo.lat
        this.geo.lng2 = this.geo.lng
        var formData = new FormData()
        formData.append('lat', this.geo.lat)
        formData.append('lng', this.geo.lng)
        formData.append('address', this.geo.address)
        formData.append('country', this.auth.country)
        formData.append('city', this.geo.city)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-mobile',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      } else this.selectAddress = 0
    },
    sendOffer () {
      this.errors = []
      if (!this.name) alert('Необходимо указать имя')
      else if (!this.phone) alert('Необходимо указать телефон')
      else if (!this.email) alert('Необходимо указать почту')
      else {
        setTimeout(function () { alert('Ваша заявка отправлена, как только мы начнем работу в вашем городе свяжемся с Вами :)') }, 1)
        var formData = new FormData()
        formData.append('crm', '13')
        formData.append('pipe', '30')
        formData.append('lead[258]', this.city.name)
        formData.append('lead[name]', this.restaurant_name)
        formData.append('contact[name]', this.name)
        formData.append('contact[256]', this.phone)
        formData.append('contact[257]', this.email)
        formData.append('contact[272]', this.city.name)
        axios.post('https://hp.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        var formData2 = new FormData()
        formData2.append('email', this.email)
        formData2.append('phone', this.phone)
        formData2.append('bonus', '1000')
        formData2.append('city', this.city.id)
        formData2.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/reg-mobile-app',
          formData2,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.title === 'Ошибка') alert(response.data.text)
        })
      }
    },
    initAjax () {
      this.categories = {}
      this.stocks = {}
      if (this.$route.query.orderId) axios.get('https://lk.when-hungry.com/mobile/check-order?uid=' + this.auth.uid + '&orderId=' + this.$route.query.orderId)
      axios.get('https://lk.when-hungry.com/mobile/categories-get?uid=' + this.auth.uid).then(response => {
        this.categories = response.data.categories
        this.stocks = response.data.stocks
        if (!Object.keys(this.categories).length) {
          this.$root.showMap = false
          this.$root.hideAll = 1
          this.categories = null
        } else this.$root.hideAll = 0
      })
    },
    initMap () {
      this.initAutocompleteInterval = setInterval(() => {
        if (this.$root.mapinit && typeof google !== 'undefined') {
          clearInterval(this.initAutocompleteInterval)
          this.initAutoComplete()
        }
      }, 500)
    },
    initAutoComplete () {
      this.geocoder = new google.maps.Geocoder()
      this.geocoder.geocode({'address': this.city.name, 'language': 'ru'}, (results, status) => {
        if (status === 'OK') {
          this.autocomplete[0] = new google.maps.places.Autocomplete(this.$refs.address, {bounds: results[0].geometry.bounds, 'language': 'ru'})
          this.autocomplete[0].addListener('place_changed', () => {
            this.changePlace(this.autocomplete[0].getPlace(), $('#address').val(), 1)
          })
        }
      })
    },
    showMap () {
      this.$root.showMap = !this.$root.showMap
    }
  }
}
</script>

<style scoped>
    .green-wave {
        top: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue